<template>

	<div class="g-facet-set__grid">
		<label class="g-facet-set__grid-item" v-for="value in facet.values.slice(0, facet.overflow.limit)" :key="value.label">
			<input class="g-form-checkbox__input" v-model="value.active" type="checkbox" @click="toggleFilter( facet.field, value.type === 'value' ? value.value : [value.low, value.high] )">
			<span class="g-facet-set__grid-item-name g-form-checkbox__caption">
				{{ value.label }}
			</span>
		</label>
		<div class="g-facet-view-more" v-if="( facet.values.length > facet.overflow.limit )">
			<input :id="'g-facet-view-more__' + facet.field" class="g-facet-view-more__checkbox u-hide-visually" type="checkbox" @change="viewMoreChange">
			<label class="g-facet-view-more__label" :for="'g-facet-view-more__' + facet.field">View More</label>
			<div class="g-facet-view-more__content">
				<label class="g-facet-set__grid-item" v-for="value in facet.values.slice(facet.overflow.limit, facet.values.length)" :key="value.label">
					<input class="g-form-checkbox__input" v-model="value.active" type="checkbox" @click="toggleFilter( facet.field, value.type === 'value' ? value.value : [value.low, value.high] )">
					<span class="g-facet-set__grid-item-name g-form-checkbox__caption">
						{{ value.label }}
					</span>
				</label>
			</div>
		</div>
	</div>

</template>

<script>

	import Search from '../../Search';

	export default {
		data() {
			return {
				uniqueId: ''
			}
		},
		props: {
			facet: {
				default() {
					return [];
				}
			}
		},
		methods: {
			toggleFilter ( field, value ) {

				Search.client.filter( field, value ).search();

			},
			viewMoreChange(event) {

				if(event.target.checked) {
					event.target.nextElementSibling.innerText = 'View Less';
				} else {
					event.target.nextElementSibling.innerText = 'View More';
				}

			}
		},
		created() {
			this.uniqueId = this._uid;
		}
	}

</script>
